import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemProps,
  MenuList,
  Portal,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { ChevronDownIcon } from '@/imports/ui/chakra/feather';
import { useFeatureFlags } from '@/imports/ui/hooks/useFeatureFlags';

import { ConferencesInactiveModal } from './components/ConferencesInactiveModal';

export const CreateConference = React.forwardRef<
  HTMLButtonElement,
  MenuItemProps
>((props, ref) => (
  <MenuItem flexDirection="column" alignItems="flex-start" {...props} ref={ref}>
    <Stack direction="row" alignItems="center">
      <Text>Create a Conference</Text>
    </Stack>
    <Text fontSize="sm" fontWeight="normal" lineHeight="base">
      Best for a larger event with a schedule of sessions and optional sponsor
      booths
    </Text>
  </MenuItem>
));

CreateConference.displayName = 'CreateConference';

export const CreationMenu: React.FC = () => {
  const { conferences } = useFeatureFlags();
  const conferencesInactiveModal = useDisclosure();

  return (
    <Box>
      <Menu>
        <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
          Create an Event
        </MenuButton>
        <MenuList maxW="xs" zIndex="popover">
          <NextLink href="/admin/event/new">
            <MenuItem flexDirection="column" alignItems="flex-start">
              <Text>Create a Simple Event</Text>
              <Text fontSize="sm" fontWeight="normal" lineHeight="base">
                Best for a single-session meeting or recording
              </Text>
            </MenuItem>
          </NextLink>
          {conferences ? (
            <NextLink href="/admin/conference/new">
              <CreateConference />
            </NextLink>
          ) : (
            <CreateConference onClick={conferencesInactiveModal.onOpen} />
          )}
          <NextLink href="/admin/events/xpro/new">
            <MenuItem flexDirection="column" alignItems="flex-start">
              <Text>Create an XPro.AI Conference</Text>
              <Text fontSize="sm" fontWeight="normal" lineHeight="base">
                Best for a conferences with end-to-end management, from registration to on-site operations and analytics.
              </Text>
            </MenuItem>
          </NextLink>
        </MenuList>
      </Menu>
      <ConferencesInactiveModal
        isOpen={conferencesInactiveModal.isOpen}
        onClose={conferencesInactiveModal.onClose}
      />
    </Box>
  );
};
